export default {
    gasket_style:{},
    product_list:{},
    stepOneProducts:{},
    profileProducts:{},
    singleProfileProducts:{},
    productPrice:0,
    productSide:'',
    depth:'',
    width:'',
    depth_display:'',
    width_display:'',
    qty:0,
    foam_fill:'',
    door_hinged:'',
    selected_type:''
}